/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S20_HeadingInputs */

const tr_mesafeli_s20_heading = /** @type {(inputs: Mesafeli_S20_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20. Uyuşmazlık Çözümü ve Yetki`)
};

const en_mesafeli_s20_heading = /** @type {(inputs: Mesafeli_S20_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20. Dispute Resolution and Jurisdiction`)
};

const de_mesafeli_s20_heading = /** @type {(inputs: Mesafeli_S20_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20. Streitbeilegung und Zuständigkeit`)
};

const ru_mesafeli_s20_heading = /** @type {(inputs: Mesafeli_S20_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20. Разрешение споров и подсудность`)
};

/**
* | output |
* | --- |
* | "20. Dispute Resolution and Jurisdiction" |
*
* @param {Mesafeli_S20_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s20_heading = /** @type {((inputs?: Mesafeli_S20_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S20_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s20_heading(inputs)
	if (locale === "de") return de_mesafeli_s20_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s20_heading(inputs)
	return tr_mesafeli_s20_heading(inputs)
});